<template>
  <div id='bd-main'>
    <form-generator></form-generator>
  </div>
</template>

<script>
import '@/plugins/formgenerator/styles/index.scss'
// import '@/plugins/formgenerator/icons'
import FormGenerator from '@/plugins/formgenerator/views/index/Home'

export default {
  name: 'bd-main',
  components: { FormGenerator },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
  },
  created() {
  },

}
</script>

<style scoped>

</style>
